import { c as _c } from "react/compiler-runtime";
const SendArrow = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m15 8-1.238 1.24-4.887-4.887V15h-1.75V4.353L2.238 9.239 1 8l7-7z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default SendArrow;